import { MvnCodeInitiate } from "../../lib/const";
import { MvnCodeBE } from "../const";

export const CDMS_STUDY_REPORT_INFO_CODE: {
  CDMS_STUDY_REPORT_INFO_SUBMITTED_EXIST: MvnCodeBE;
  CDMS_STUDY_REPORT_INFO_SHOULD_SYNC_AT_ONCE: MvnCodeBE;
} = {
  CDMS_STUDY_REPORT_INFO_SUBMITTED_EXIST: {
    status: 400,
    ko: "제출된 보고서가 존재합니다.",
    en: "A submitted report exists.",
  },
  CDMS_STUDY_REPORT_INFO_SHOULD_SYNC_AT_ONCE: {
    status: 400,
    ko: "Merge Table 데이터는 한 번에 sync 해야 합니다. {tableId}",
    en: "Merge Table data can only be synced in a single batch. {tableId}",
  },
};

MvnCodeInitiate(CDMS_STUDY_REPORT_INFO_CODE);
